import defaultEn from '@/locales/default/messages.en.json'
import defaultFr from '@/locales/default/messages.fr.json'
import defaultEs from '@/locales/default/messages.es.json'
import defaultDe from '@/locales/default/messages.de.json'
import defaultIt from '@/locales/default/messages.it.json'

// You must add networks ids to this array to import their translations
const networksToImport = [57, 79, 89, 120, 138, 144]

const requireLocaleFiles = (filepath) => {
    try {
        return require('@/locales/network/' + filepath)
    } catch (e) {
        return {}
    }
}

/**
 * Imports all the translations for a locale for all the networks in the networksToImport array
 * @param {string} locale The locale you want to import the translations for
 * @returns {object} An object containing all the translations for the locale
 */
const requireNetworksTranslationsForLocale = (locale) => {
    // For each network to import
    const networkTranslations = networksToImport.map((networkId) => {
        // We import the translations for the network
        const translationObject = requireLocaleFiles(`${networkId}/messages.${locale}.json`)
        const prefixedTranslationObject = {}

        // And we create a new object, prefixing all the keys with the network id
        Object.keys(translationObject).forEach((key) => {
            prefixedTranslationObject[`${networkId}.${key}`] = translationObject[key]
        })

        return prefixedTranslationObject
    })

    // We merge all the network translations into one object
    return networkTranslations.reduce((acc, translationObject) => {
        return Object.assign({}, acc, translationObject)
    })
}

export default {
    en: Object.assign({}, defaultEn, requireNetworksTranslationsForLocale('en')),
    fr: Object.assign({}, defaultFr, requireNetworksTranslationsForLocale('fr')),
    es: Object.assign({}, defaultEs, requireNetworksTranslationsForLocale('es')),
    de: Object.assign({}, defaultDe, requireNetworksTranslationsForLocale('de')),
    it: Object.assign({}, defaultIt, requireNetworksTranslationsForLocale('it'))
}
